<template>
    <div class="widget-container" v-if='!isDashboardLoading && traductionsLoaded'>
        <span v-for='widget in listeWidgets' :key='widget.id' class='display-content'>
            <InterventionRequest v-if='widget.typeWidgetId === TYPE_WIDGET_DEMANDE_INTERVENTION_ID()' :widget='widget' class='ombre'/>
            <Preventive v-if='widget.typeWidgetId === TYPE_WIDGET_PREVENTIVE_ID()' :widget='widget' class='ombre'/>
            <PreventiveOut v-if='widget.typeWidgetId === TYPE_WIDGET_INTERVENTION_ID()' :widget='widget' class='ombre'/>
            <Estimate v-if='widget.typeWidgetId === TYPE_WIDGET_DEVIS_ID()' :widget='widget' class='ombre'/>
            <Billing v-if="hasRightFinancier && widget.typeWidgetId === TYPE_WIDGET_FACTURE_ID()" :widget='widget' class='ombre'/>
        </span>

        <div class='height-1px'></div>

        <HomePageModale v-if="showHomePageModal"/>
        <Modal v-if="showEnqueteModal" @cancel="showEnqueteModal = false" :closeOnClickOutside="false">
            <EnqueteModalContent @close="showEnqueteModal = false" @answer="handleAnswer" />
        </Modal>
    </div>

    <LoaderComponent v-else/>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import Estimate from '@/modules/Home/components/Estimate.vue';
import PreventiveOut from '@/modules/Home/components/PreventiveOut.vue';
import InterventionRequest from '@/modules/Home/components/InterventionRequest.vue';
import Preventive from './Preventive.vue';
import Billing from '@/modules/Home/components/Billing.vue';
import Modal from '@/components/ui-components/Modal.vue';
import EnqueteModalContent from '@/modules/Home/components/EnqueteModalContent.vue';
import HomePageModale from './HomePageModale.vue';
import { store } from '@/plugins/store';
import SatisfactionService from '@/modules/Satisfaction/services/SatisfactionService';
import dayjs from 'dayjs';
import { Widget } from '@/models/Widget';
import LoaderComponent from '@/components/ui-components/LoaderComponent.vue';
import {
    TYPE_WIDGET_DEMANDE_INTERVENTION_ID,
    TYPE_WIDGET_DEVIS_ID,
    TYPE_WIDGET_FACTURE_ID,
    TYPE_WIDGET_INTERVENTION_ID,
    TYPE_WIDGET_PREVENTIVE_ID
} from '@/constantes/constantes';

interface Data {
    isAutenticationModaleClosed: boolean,
}

export default defineComponent({
    name: 'HomeMain',
    methods: {
        TYPE_WIDGET_DEVIS_ID() {
            return TYPE_WIDGET_DEVIS_ID;
        },
        TYPE_WIDGET_INTERVENTION_ID() {
            return TYPE_WIDGET_INTERVENTION_ID;
        },
        TYPE_WIDGET_PREVENTIVE_ID() {
            return TYPE_WIDGET_PREVENTIVE_ID;
        },
        TYPE_WIDGET_DEMANDE_INTERVENTION_ID() {
            return TYPE_WIDGET_DEMANDE_INTERVENTION_ID;
        },
        TYPE_WIDGET_FACTURE_ID() {
            return TYPE_WIDGET_FACTURE_ID;
        }
    },
    components: {
        LoaderComponent,
        Estimate,
        PreventiveOut,
        InterventionRequest,
        Preventive,
        Billing,
        HomePageModale,
        Modal,
        EnqueteModalContent,
    },
    setup() {
        const showEnqueteModal = ref(false);
        const router = useRouter();

        // Fonction pour v�rifier si la modal doit s'afficher
        const checkEnqueteModalConditions = async () => {
            try {
                const response = await SatisfactionService.getSatisfactionConditions();

                const modalConditions = response.modalConditionDTO;
                if (modalConditions?.afficherRappelModal === true &&
                    modalConditions.dateCreationCompteSuperieur6Mois &&
                    modalConditions.CANonNull &&
                    (modalConditions.dateSaisieIsNull || dayjs(response.dateSaisie) < dayjs().subtract(1, 'year')) &&
                    modalConditions.active) {
                        showEnqueteModal.value = true;
                }
            } catch (error) {
                console.error("Erreur lors de la r�cup�ration des conditions d'enqu�te:", error);
            }
        };

        onMounted(() => {
            checkEnqueteModalConditions();
        });

        // Gestion des r�ponses � l'enqu�te
        const handleAnswer = () => {
            showEnqueteModal.value = false;
            router.push('/satisfaction');
        };

        return {
            showEnqueteModal,
            handleAnswer
        };
    },
    data(): Data {
        return {
            isAutenticationModaleClosed: false,
        };
    },
    mounted() {
        //store.dispatch(HomeAction.GET_NB_NOUVELLES_RECLAMATIONS);
    },
    computed: {
        isDashboardLoading(): boolean {
            return this.$store.getters.isDashboardLoading;
        },
        loadIcon() {
            return require('@/assets/img/logo.svg');
        },
        showHomePageModal() {
            return store.getters.getShowModaleCommunication;
        },
        hasRightFinancier(): boolean {
            return this.$store.getters.getUserInformations.fonctions.includes('consulter.facture.recue');
        },
        actualites() {
            return this.$store.getters.getActualites;
        },
        isB2cAccountValid() {
            return this.$store.getters.getUser?.email_azure !== undefined;
        },
        traductionsLoaded() {
            return this.$store.getters.getLangueSelectionnee != undefined;
        },
        listeWidgets(): Widget[]{
            if (this.$store.getters.getSelectedDashboard == undefined || this.$store.getters.getSelectedDashboard.widgets == undefined) {
                return [];
            }
            return [...this.$store.getters.getSelectedDashboard.widgets]
                .sort((a: Widget, b: Widget) => a.position - b.position);
        }
    },
});
</script>

<style scoped>
@media screen and (min-width: 980px) {
    .widget-container{
        height: 92%;
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        padding-left: 50px;
    }
}
@media screen and (max-height: 800px) {
    .widget-container{
        height: 89%;
    }
}
@media (max-width: 1000px) {
    .widget-container{
        margin-right: auto;
        margin-left: auto;
    }
}
@media (min-width: 980px) and (max-width: 1005px){
    .widget-container{
        height: auto;
        flex-flow: column wrap;
    }
}
.display-content{
    display: contents;
}
.display-content > span{
    order: 0;
    margin-left: 1%;
}
.height-1px{
    height: 1px;
    width: 100%;
}
.ombre {
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px rgba(0, 0, 0, .14), 0 1px 5px rgba(0, 0, 0, .12);
}
</style>
